module.exports = __webpack_public_path__ + "static/media/ic_auth_emandate_fisdom.2ba12947.svg";